import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, style }: SvgIconProps) => (
  <img style={style} src={`/img/svg/${src}`} alt={src} width={width} height={height} />
);
